import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { authStoreStateSelector } from '~/selectors';

export const useLoggedInUserRoles = (): string[] => {
  return useSelector((state: StoreState) => {
    return authStoreStateSelector(state).userDetails?.roles ?? [];
  });
};
